import React, { useEffect } from 'react';
import { useState } from 'react';
import { toast } from 'react-toastify';
import { getContract, uploadImageToIPFS, uploadToIPFS } from '../hooks/contractHelper';
import daoAbi from '../json/daoAbi.json';
import { contract, DEFAULT_CHAIN } from '../hooks/constant';
import { getWeb3 } from '../hooks/connectors';
import { useAccount, useNetwork } from 'wagmi';
import { useEthersSigner } from '../hooks/useEthersProvider';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import Footer from '../components/Footer';



export default function Authorized() {
  const { address: account } = useAccount();
  const { chain } = useNetwork();
  const library = useEthersSigner();
  const [pinfo, setPinfo] = useState('');
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState("");
  const [images, setImages] = useState([]);
  const [type, setType] = useState(0);
  const [thumb, setThumb] = useState('');
  const [inputFields, setInputFields] = useState([{
    service: 'Yes',
  }]);
  const history = useHistory();

  useEffect(() => {
    let isLogin = localStorage.getItem("blockstardao");
    if (isLogin === null || isLogin === 'null') {
      history.push('/')
    }

  }, []);

  const addInputField = () => {

    setInputFields([...inputFields, {
      service: '',
    }])

  }

  const removeInputFields = (index, e) => {
    e.preventDefault();
    const rows = [...inputFields];
    rows.splice(index, 1);
    setInputFields(rows);
  }

  const handleChange = (index, evnt) => {
    const { name, value } = evnt.target;
    const list = [...inputFields];
    list[index][name] = value;
    setInputFields(list);
  }


  const handleImageUpload = (e) => {
    const files = Array.from(e.target.files);
    const newImages = files.map((file) => ({ file, url: URL.createObjectURL(file) }));
    setImages((prev) => [...prev, ...newImages]);
  };

  const handleThumbUpload = (e) => {
    const file = e.target.files[0]; // Get the first file
    setThumb(file);
  };

  // Remove an image
  const handleRemoveImage = (index) => {
    const updatedImages = [...images];
    updatedImages.splice(index, 1);
    setImages(updatedImages);
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (account) {
        if (chain && chain.id && parseInt(chain.id) === parseInt(DEFAULT_CHAIN)) {
          const rows = [...inputFields];
          let voteOption = [];
          rows.map((product) => {
            if (product.service !== '') {
              voteOption.push(product.service);
            }
            return true;
          })

          if (pinfo !== '' && voteOption.length > 0) {
            const hashes = [];
            const thumbHash = await uploadImageToIPFS(thumb)
            if (!thumbHash) {
              toast.error('Thumbnail upload error!')
              return;
            }
            // Upload all images to IPFS
            for (const img of images) {
              const hash = await uploadImageToIPFS(img.file);
              if (hash) hashes.push(hash);
            }

            const metadata = {
              title: title,
              description: pinfo,
              images: hashes,
              thumb: thumbHash
            };

            const metadataHash = await uploadToIPFS(metadata);

            if (metadataHash && metadataHash !== '') {
              let daoContract = getContract(daoAbi, contract[DEFAULT_CHAIN].DAO_ADDRESS, library);
              let tx = await daoContract.createProposal(metadataHash, voteOption, type, { 'from': account });
              toast.loading('Waiting for confirmation..');

              var interval = setInterval(async function () {
                let web3 = getWeb3();
                var response = await web3.eth.getTransactionReceipt(tx.hash);
                if (response != null) {
                  clearInterval(interval)
                  if (response.status === true) {
                    toast.dismiss();
                    toast.success('success ! your last transaction is success');
                    setLoading(false);
                  }
                  else if (response.status === false) {
                    toast.dismiss();
                    toast.error('error ! Your last transaction is failed.');
                    setLoading(false);
                  }
                  else {
                    toast.dismiss();
                    toast.error('error ! something went wrong.');
                    setLoading(false);
                  }
                }
              }, 5000);

            }
            else {
              toast.error('hash not found on upload ! Please try again');
            }
          }
          else {
            toast.dismiss();
            toast.error('Please enter valid details!!');
            setLoading(false);
          }
        }
        else {
          toast.dismiss();
          toast.error('Please connect to mainnet chain!!');
          setLoading(false);
        }
      }
      else {
        toast.dismiss();
        toast.error('Please connect wallet!!');
        setLoading(false);
      }
    }
    catch (err) {
      toast.dismiss();
      toast.error(err.reason ? err.reason : err.message);
      setLoading(false);
    }
  }

  return (
    <div id="main-wrapper">
      <Header />
      <Sidebar />
      <div className="page-wrapper mt-4">
        <div className='container-fluid'>
          <div className="row">
            <div className="col-12">
              {account ? (
                <div className="card">
                  <div className="card-body">
                    <div className="col-12">
                      <div className="card">
                        <div className="card-body">
                          <h4 className="card-title">Create Proposal</h4>
                          <form className="form-horizontal mt-4">
                            <div className="form-group">
                              <label className="form-label">Proposal Title</label>
                              <input type='text' value={title} className="form-control" name="title" onChange={(e) => setTitle(e.target.value)} />
                            </div>
                            <div className="form-group">
                              <label className="form-label">Proposal Information</label>
                              <textarea className="form-control" onChange={(e) => {
                                setPinfo(e.target.value);
                              }} rows="5">{pinfo}</textarea>
                            </div>

                            <div className="form-group">
                              <label className="form-label">Select Type</label>
                              <select class="form-select" name="type" onChange={(e) => setType(e.target.value)}>
                                <option value={0} selected={type === 0}>NFT Holder Only</option>
                                <option value={1} selected={type === 1}>All Users Only</option>
                              </select>
                            </div>

                            {/* Thum Upload */}
                            <div className="form-group">
                              <label className="form-label">Thumbnail Image Upload</label>
                              <input
                                type="file"
                                accept="image/*"
                                className='form-control'
                                onChange={handleThumbUpload}
                              />
                            </div>

                            {/* Image Upload */}
                            <div className="form-group">
                              <label className="form-label">Upload Images</label>
                              <input
                                type="file"
                                accept="image/*"
                                className='form-control'
                                multiple
                                onChange={handleImageUpload}
                              />
                            </div>



                            {/* Display Uploaded Images */}
                            <div className="image-preview-container d-flex mb-5">
                              {images.map((img, index) => (
                                <div key={index} className="image-preview">
                                  <img src={img.url} height="100px" width="100px" alt="preview" className="preview-image" />
                                  <button
                                    type="button"
                                    className="remove-btn"
                                    onClick={() => handleRemoveImage(index)}
                                  >
                                    &#10005;
                                  </button>
                                </div>
                              ))}
                            </div>

                            <div className="form-group">
                              <label className="form-label">Voting Option</label>
                              <div className='col-sm-6'>

                                {
                                  inputFields.map((data, index) => {
                                    const { service } = data;
                                    return (
                                      <div className="input-group">

                                        <input type="text" onChange={(evnt) => handleChange(index, evnt)} value={service} name="service" className="form-control mb-1" placeholder="Enter option value.." />
                                        {(index === 0) ? (
                                          <div className="input-group-append text-end">
                                            <button className="btn btn-success text-white mx-1" type="button" onClick={(e) => addInputField(e)}>
                                              <i className="fa fa-plus"></i>
                                            </button>
                                          </div>

                                        ) : (
                                          <div className="input-group-append">
                                            <button className="btn btn-success text-white mx-1" type="button" onClick={(e) => removeInputFields(index, e)}>
                                              <i className="fa fa-minus"></i>
                                            </button>
                                          </div>
                                        )}

                                      </div>
                                    )
                                  })
                                }
                              </div>
                            </div>


                            <div className="form-actions">
                              <div className="card-body text-center">
                                <button type="button" disabled={loading} className="btn btn-success text-white" onClick={(e) => handleSubmit(e)}>
                                  {loading ? 'loading...' : 'Create'}
                                </button>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="card">
                  <div className="card-body">
                    <div className="col-md-12 mt-5 mb-5">
                      <div className="text-center">
                        <h1 className="w3-jumbo w3-animate-top w3-center"><code>Access Denied</code></h1>
                        <hr className="w3-border-white w3-animate-left" style={{ "margin": "auto", "width": "50%" }} />
                        <h3 className="w3-center w3-animate-right">You dont have permission to view this page.</h3>
                        <h3 className="w3-center w3-animate-zoom">🚫🚫🚫🚫</h3>
                        <h6 className="w3-center w3-animate-zoom">error code:403 forbidden</h6>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}
